import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const MultistageRoSeawaterRoRecycling: React.FC = () => {
  return (
    <>
      <PageHeader title="Multi-stage RO / Seawater RO Recycling Systems" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-2.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-4.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Multi-stage RO / Seawater RO Recycling Systems</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Multi-stage RO (Reverse Osmosis) and Seawater RO Systems are advanced membrane-based recycling solutions that treat highly contaminated or saline wastewater for reuse. At Wasser Technochem (India) Ltd., we design and implement custom-built, energy-efficient RO systems capable of handling high TDS, COD, and complex effluent loads, especially from ZLD-based industries and coastal regions.</p>
              <p>These systems are vital for zero liquid discharge (ZLD), wastewater reuse, and industrial process recovery, helping industries meet stringent discharge norms while reducing freshwater dependency.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-tshirt text-primary me-2"></i>Textile dyeing and finishing units</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical, pharma & pesticide industries</p>
              <p><i className="fa fa-water text-primary me-2"></i>Coastal desalination + industrial reuse</p>
              <p><i className="fa fa-fire text-primary me-2"></i>Power plants and cooling tower blowdown recovery</p>
              <p><i className="fa fa-filter text-primary me-2"></i>ETP tertiary treatment and polishing</p>
              <p><i className="fa fa-recycle text-primary me-2"></i>Industrial ZLD schemes with evaporators</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL offers custom-engineered multistage RO systems including brine concentrators, energy recovery units, and membrane cleaning setups to ensure reliable long-term operation.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-chart-line text-primary me-2"></i>Design Capacities: 5 KLD to 5+ MLD</h5>
                <p className="ms-4">Based on feed characteristics and desired recovery.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-layer-group text-primary me-2"></i>Multi-stage RO Configuration:</h5>
                <div className="ms-4">
                  <p>• Stage 1: Primary RO (high recovery)</p>
                  <p>• Stage 2: Brine RO or High-Pressure RO (HPRO)</p>
                  <p>• Optional: NF/UF as pre-treatment</p>
                  <p>• Optional: MEE/ATFD as final ZLD stage</p>
                </div>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-water text-primary me-2"></i>Seawater RO (SWRO) integration for high TDS feedwater</h5>
                <p className="ms-4">Using corrosion-resistant piping and duplex SS membranes.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-desktop text-primary me-2"></i>Automated CIP, interlocks & monitoring systems</h5>
                <p className="ms-4">Integrated with SCADA/PLC control.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Achieves &gt;90% water recovery</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces wastewater volume drastically</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Enables reuse in process, utilities, or flushing</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Protects downstream ZLD equipment like MEE</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Meets SPCB & CPCB guidelines for effluent discharge</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Expertise in handling high TDS/high COD effluent streams</p>
              <p><i className="fa fa-star text-warning me-2"></i>End-to-end solutions: Feed analysis → Pilot → Engineering → Execution</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house membrane design, skid fabrication, and automation</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Over 30 successful multi-stage RO systems across India</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default MultistageRoSeawaterRoRecycling;
